import styled from 'styled-components';
import ArrowDownIcon from '../../../../../Icons/ArrowDownIcon';

export const HotelInfoLoader = styled.div(
  props => `
  
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin: 0 auto;
    width:79.3rem;
    background-color:${props.theme.colors.goWhite.base};
    border-radius:${props.theme.misc.borderRadius.large};
  
  `,
);

export const HeaderWithIconWrap = styled.div(
  props => `
  display:flex;
  align-items:center;
  justify-content: space-between;
  padding: ${props.theme.spacing.large} ${props.theme.spacing.custom(30)};
`,
);

export const HotelInfoHeader = styled.div(
  props => `
    display:flex;
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
    width:20rem;
    height:3.6rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
  
  `,
);

export const ArrowDownWrap = styled.div(
  props => `
  display:flex;
  justify-content:center;
  align-items:center;
  background:${props.theme.colors.goBrandBlue.light};
  border-radius:50%;
  height:2.6rem;
  width:2.6rem;
`,
);

export const ArrowDown = styled(ArrowDownIcon)(
  props => `
  width:1rem;
  height:1rem;
  fill:${props.theme.colors.downriver.medium};
  `,
);

export const SpecialDealOuterWrap = styled.div(
  props => `
    display:flex;
  
  `,
);

export const SpecialDealWrap = styled.div(
  props => `
    display:flex;
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
    width:100%;
    height:4.2rem
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
  
  `,
);

export const HotelInfoOuterWrap = styled.div(
  props => `
    display:flex;
    padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.custom(30)} ${
    props.theme.spacing.large
  };
  `,
);

export const ImageContainer = styled.div(
  props => `
    display:flex;
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
    width:13.9rem;
    height:9.5rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
    margin: 0 ${props.theme.spacing.xlarge} 0 0 ;
  
  `,
);

export const HotelDetailsWrap = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  
  `,
);

export const HotelNameLoader = styled.div(
  props => `
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
    width:25.9rem;
    height:2.2rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
    margin: 0 0 ${props.theme.spacing.small} 0 ; 
  `,
);

export const HotelLocationLoader = styled.div(
  props => `
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
    width:23.3rem;
    height:2.2rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
    margin: 0 0 ${props.theme.spacing.small} 0; 
  `,
);

export const HotelRatingLoader = styled.div(
  props => `
    display:flex;
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
    width:6.8rem;
    height:1.9rem
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
  `,
);

export const CheckinCheckoutWrap = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    margin: 0 ${props.theme.spacing.custom(30)} 0 0; 
  `,
);

export const CheckingOuterWrap = styled.div(
  props => `
    display:flex;
    border: .1rem solid ${props.theme.colors.ash.medium};
    border-radius: ${props.theme.misc.borderRadius.base};
    padding:${props.theme.spacing.base}; 
    margin: 0 ${props.theme.spacing.custom(30)} ${props.theme.spacing.large};
  `,
);

export const CheckInTitle = styled.div(
  props => `
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
    width:6.8rem;
    height:1.9rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
    margin: 0 0 ${props.theme.spacing.xsmall} 0; 
  `,
);

export const CheckInDay = styled.div(
  props => `
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
    width:9.8rem;
    height:1.9rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
    margin: 0 0 ${props.theme.spacing.xsmall}  0; 
  `,
);

export const CheckInTime = styled.div(
  props => `
    display:flex;
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
    width:6.8rem;
    height:1.9rem
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
  `,
);

export const RoomTitleOuterWrap = styled.div(
  props => `
    display:flex;
    border-top: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
    margin: 0 0 ${props.theme.spacing.base} 0;
    padding: ${props.theme.spacing.base} ${props.theme.spacing.custom(30)} ${
    props.theme.spacing.base
  };
  `,
);

export const RoomTitleWrap = styled.div(
  props => `
    width:20rem;
    height:2.5rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};

  `,
);

export const RoomDetailsContainer = styled.div(
  props => `
    display: flex;
    padding: ${props.theme.spacing.base} ${props.theme.spacing.custom(
    30,
  )} ${props.theme.spacing.custom(35)};
  `,
);

export const RoomImage = styled.div(
  props => `
    width:13.9rem;
    height:9.5rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
    margin: 0 ${props.theme.spacing.custom(35)} 0 0;

  `,
);

export const RoomDetailsWrap = styled.div(
  props => `
    // width:20rem;
    // height:2.5rem
    // border-radius: ${props.theme.misc.borderRadius.small};
    // background-color:${props.theme.colors.goBrandBlue.medium};
  `,
);

export const PriceIncludes = styled.div(
  props => `
    width:8.8rem;
    height:1.6rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
    margin: 0 0 ${props.theme.spacing.base} 0;
  `,
);

export const FreeAmenities = styled.div(
  props => `
    width:17rem;
    height:1.6rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
    margin: 0 0 ${props.theme.spacing.base} 0;
  `,
);

export const CancellationPolicy = styled.div(
  props => `
    width:17rem;
    height:2.2rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
    margin: 0 0 ${props.theme.spacing.base} 0;
  `,
);

export const ViewBooking = styled.div(
  props => `
    width:11.8rem;
    height:1.6rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
  `,
);
